import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

var COMP = environment.component.resilience;
export interface Element {
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
  column7: string;
  column8: string;
}

const ELEMENT_DATA: Element[]=[
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "A1",
     column6: "No",
     column7: "Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015",
     column8: "Number of [deaths/Deceased] and [missing[persons] / presumed dead] due to hazardous events per 100,000\nAlt) Number of deaths, missing, injured, displaced or [evacuated] due to hazardous events per 100,00"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "A2",
     column6: "No",
     column7: "Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015",
     column8: "Number of [deaths/deceased] due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "A3",
     column6: "No",
     column7: "Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015",
     column8: "Number of [missing [persons] / presumed dead] due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B1",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of affected people [by hazardous event / due to hazardous events] per 100,00"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B2",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of injured or ill people due to hazardous events.\nAlt) Number of people suffering from physical injuries, trauma or cases of disease requiring immediate medical assistance as a direct result of a hazardous event."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B3",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of people who left their [places of residence / home][and places where they are] due to hazardous events.\nAlt) Number of people displaced due to hazardous events\nAlt-bis) Number of people evacuated, relocated and displaced due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B4",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of people whose [houses / dwellings or homes] were damaged due to hazardous events."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B5",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of people whose [houses / dwellings or homes] were destroyed due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B6",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of people who [received / required] [food relief aid / aid including food [and non-food] and medical aid] [among other things] due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "B7",
     column6: "No",
     column7: "Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015",
     column8: "Number of people whose livelihoods were disrupted, destroyed or lost due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C1",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2030",
     column8: "Direct economic loss due to hazardous events [in relation to global gross domestic product"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C2",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2031",
     column8: "Direct agricultural loss due to hazardous events."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C3",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2032",
     column8: "Direct economic loss due to industrial facilities damaged or destroyed by hazardous events."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C4",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2033",
     column8: "Direct economic loss due to commercial facilities [and services] damaged or destroyed by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C5",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2034",
     column8: "Direct economic loss due to houses damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C6",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2035",
     column8: "Direct economic loss due to houses destroyed by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C7",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2036",
     column8: "Direct economic loss due to damage to [critical infrastructure / public infrastructure] caused by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C8",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2037",
     column8: "Direct economic loss due to cultural heritage damaged or destroyed by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C9",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2038",
     column8: "Direct economic loss due to environment degraded by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C10",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2039",
     column8: "Financial transfer and access to insurance"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C11",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2040",
     column8: "Direct economic losses due to disruptions to basic services"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "C12",
     column6: "No",
     column7: "Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2041",
     column8: "Direct economic loss due to services sectors (such as transportation, tourism, finance) caused by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D1",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2030",
     column8: "Damage to critical infrastructure due to hazardous events  bis) Number of electricity plants and transmission towers destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D2",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2031",
     column8: "[Number / percentage] of health facilities [including mental health services.] destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D3",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2032",
     column8: "[Number / percentage] of educational facilities destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D4",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2033",
     column8: "[Number / percentage] of [major] transportation [units and] infrastructures destroyed or damaged by hazardous events."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D5",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2034",
     column8: "[Number / Length / Percentage] of [time / days / person days] basic services have been disrupted due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D6",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2035",
     column8: "[Number / Percentage] of education or health facilities [removed from risk areas / retrofitted"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D7",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2036",
     column8: "[Number / percentage] of security service structures destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D8",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2037",
     column8: "[Number / percentage] of tourist infrastructure facilities destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D9",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2038",
     column8: "Number of states with resilience programmes or strategies for health and education facilities"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D10",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2039",
     column8: "Number of communication infrastructure destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D11",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2040",
     column8: "Percentage of education facilities developed under the safe school program"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D12",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2041",
     column8: "Percentage of health facilities developed under the safe hospital program"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D13",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2042",
     column8: "Number of agricultural facilities destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D14",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2043",
     column8: "Number of water and sanitation infrastructures destroyed or damaged by hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "D15",
     column6: "No",
     column7: "Substantially reduce disaster damage to critical \ninfrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2044",
     column8: "Number of days financial services have been disrupted due to hazardous events"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E1",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2020",
     column8: "Number countries that adopt and implement national DRR strategies in line with Sendai for DRR 2015-2030\n\nAlt) Number of countries with national DRR strategies for implementation of Sendai Framework"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E2",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2021",
     column8: "Percentage of local governments that adopt and implement local DRR strategies in line with Sendai / national disaster risk strategy\n\nAlt)  Number of countries and local governmental that adopt and implement local and sector specific DRR strategies in line with Sendai\nAlt-bis) Percentage of local governments with DRR strategy for implementation of national strategy for Sendai"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E3",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2022",
     column8: "Number of countries that integrate climate change / adaption into development planning (or have)\n\nAlt) Number of countries that have integrated DRR and climate change into their national development plan"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E4",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2023",
     column8: "Number of countries that adopt and implement critical infrastructure protection plan\n\nbis) Number of countries with resilience programmes or strategies for health and education facilities in the framework of the DRR plans\nter) Number of sector/hazard specific DRR strategy/plan development in a country"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E5",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2024",
     column8: "Number of countries with cross-sectoral bodies/forums, with clear roles and responsibilities identified across state institutions, civil society, private sector and international actors , in the implementation and review of DRR measures\n\nAlt) Number of countries that adopt and implement specific DRR strategies in line with the Sendai Framework, including cross-sectoral bodies/forums with identified roles and responsibilities, as appropriate, for relevant actors"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E6",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2025",
     column8: "Number of countries accounting for future risk in public and private balance sheets, setting financial targets to inform investment strategies for reducing risk and enhancing future prosperity"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E7",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2026",
     column8: "Number of countries and local governments conducting (independent) periodic outcome reviews of the implementation of national and local DRR strategies"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E8",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2027",
     column8: "Number of countries that adopt and implement sector specific DRRR strategies in line with the Sendai framework"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E9",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2028",
     column8: "Number of countries that have national financing mechanisms for DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E10",
     column6: "Yes",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2029",
     column8: "Number of countries that have spatial and land use planning mechanisms for DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E11",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2030",
     column8: "Number of countries that mainstream DRR into national development planning)"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E12",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2031",
     column8: "Number of people protected by evacuation, improved infrastructure and other relevant measures that reduce the possible impact of disasters on people"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E13",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2032",
     column8: "Number of people who received/require relief aid or assistance due to a hazardous event"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "E14",
     column6: "No",
     column7: "Substantially increase the number of countries with \nnational and local disaster risk reduction strategies by 2033",
     column8: "Number of people who received/require relief aid or assistance due to a hazardous event"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F1",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2030",
     column8: "Percentage of gross national product that represents the non-earmarked  adequate  support provided by developed countries and reported by developing countries\nAlt) percentage of earmarked ODA provided by developed countries and reported by developing countries"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F2",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2031",
     column8: "Number of developed countries having a policy marker as part of legislation on provisions for support to developing countries to enhance the implementation of the Sendai framework and the fulfilment of global goals"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F3",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2032",
     column8: "Progress on the implementation of paragraph 47 of the Sendai framework, in particular subparagraphs 47(a) and 47(b)"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F4",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2033",
     column8: "Progress in using the regional platforms for  exchange of best practices, technology and capacity building in  enhancing south-south cooperation for the implementation of Sendai"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F5",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2034",
     column8: "F-5) Number of projects and programmes funded  by international organizations in line with paragraph 48 of Sendai"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F6",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2035",
     column8: "Net ODA for disaster risk reduction, (total and to LDC) as a percentage of total ODA"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F7",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2036",
     column8: "Number of countries supported in implementing national DRR strategies by aligned programmes of entities of the UN System\n\nAlt) Amount of resources given to support developing countries implementation of national DRR strategies by programmes of entities of the UN system and other relevant stakeholders"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F8",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2037",
     column8: "Number of international (multilateral/bilateral) financial institutions that systematically integrate climate change adaption and disaster risk reduction into the design, implementation and evaluation of Official Development Finance / urban planning etc."
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F9",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2038",
     column8: "Number of countries with international and regional initiatives for the exchange of science, technology and innovation in disaster risk reduction\n\nAlt) Number of developed countries supporting developing countries' regional initiatives for the exchange of science, knowledge, technology and innovation in DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F10",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2039",
     column8: "Total amount of funding within ODA to promote the development, transfer, dissemination and diffusion of DRR-related science, technology and innovation (STI)"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F11",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2040",
     column8: "Number of international and regional multi-stakeholder partnerships established to build individual, institutional and societal capacity for DRRR / DRR capacity in developing countries and the economic value of such partnerships\n\nAlt)  Number of countries that have regional cooperation to support DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F12",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2041",
     column8: "Number of countries having participated in a voluntary and mutual review of progress in implementing respective national DRR strategies"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F13",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2042",
     column8: "Financial and other resources made available to strengthen the statistical capacity of developing countries in collection, analysis and management and use of DRR info"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F14",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2043",
     column8: "Number of voluntary commitments by international and regional organisations / initiatives related to DRR capacity building of developing countries"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F15",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2044",
     column8: "Annual percentage of cooperation financing for DRR provided by developed countries and received by developing countries compared with the economic loses registered in developing countries"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F16",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2045",
     column8: "Total amount of funds provided by developed countries to developing countries to promote development and transfer of ecologically adequate, appropriate and modern technology for DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F17",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2046",
     column8: "Proportion of cooperation funds for DRR provided by developing countries and registered in the annual budgets of developing countries"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F18",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2047",
     column8: "Estimated proportion of cooperation for DRR covered by indicative expenditure and/or implementation plans from developed countries for 1,2,3 years in advance"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F19",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2048",
     column8: "Financial or other resources provided for capacity building to developing countries to strengthen the implementation of their national strategies for DRR"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "F20",
     column6: "No",
     column7: "Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2049",
     column8: "Number of developing/developed countries fostering an enabling environment domestically, to reduce the barriers for technology transfer to developing countries, including through the implementation of national DRR strategies and enhanced mobilization of domestic resources"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G1",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2030",
     column8: "Number of countries that have coordinated  multi-hazard early warning system"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G2",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2031",
     column8: "Number of countries that be coordinated  multi-hazard monitoring and forecasting system"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G3",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2032",
     column8: "Number/percentage of people who are covered by and have access to  multi-hazard early warning systems (per 100,000)"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G4",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2033",
     column8: "Percentage/number of local and national  governments having preparedness plan (including EWS response and evacuation components) or evacuation plan tested on regular basis and standard operating procedures"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G5",
     column6: "Yes",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2034",
     column8: "Number/percentage of countries that have multi-hazard national risk assessment / risk information with results in an accessible understandable and useable format for stakeholders and people\n\nAlt) Multi-hazard risk information system capable of providing information in a simple and usable format to common people"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G6",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2035",
     column8: "Percentage/number of local governments that have multi-hazard risk assessment/risk information, with results in an accessible understandable and usable format for stakeholders and people"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G7",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2036",
     column8: "Percentage of population with understanding of the risk they are exposed to\n\nAlt) Number of countries with programmes for the DR perception and understanding of the population"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G8",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2037",
     column8: "Number of countries that have national plans with budget and timeline for development of multi-hazard EWS"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G9",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2038",
     column8: "Number of countries that have disaster loss databases publicly accessible"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G10",
     column6: "Yes",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2039",
     column8: "Number of countries that have open data policies and mechanisms to make hazard and risk data accessible and available to all users"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G11",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2040",
     column8: "How many countries provide basic weather, environmental and climate services, as defined by the World meteorological Organization"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G12",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2041",
     column8: "Percentage of people in local communities able to use indigenous knowledge of the risk they are exposed to"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G13",
     column6: "No",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2042",
     column8: "Percentage of local communities trained in community based multi-hazard early warning management system and response"
  },
  {
     column1: "Sendai Framework for Disaster Risk Reduction",
     column2: "http://www.preventionweb.net/drr-framework/sendai-framework/",
     column3: "None found",
     column4: "None",
     column5: "G14",
     column6: "Yes",
     column7: "Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2043",
     column8: "Number of programmes to enhance awareness, disaster risk information and risk assessment"
  }
 ];
@Component({
  selector: 'app-resilience',
  templateUrl: './resilience.component.html',
  styleUrls: ['./resilience.component.css']
})
export class ResilienceComponent implements OnInit {

//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".resilience-click").addClass("header_active")
  }
  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  addQuestion(){
    this.router.navigateByUrl('/sdg/add-question/'+COMP)
  }
  quesBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-report')
  }
  homeBtnClick(){
    this.router.navigateByUrl('/sdg/sdg-home')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/resilience/resilience.component.ts